import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Params, Router } from '@angular/router';

@Component({
  selector: 'qaroni-come-back-button',
  templateUrl: './come-back-button.component.html',
  styleUrl: './come-back-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ComeBackButtonComponent {
  readonly routerLinkUrl = input<string[]>([]);
  readonly text = input<string>('Volver');
  readonly queryParams = input<Params>({});

  private router = inject(Router);
  private location = inject(Location);

  get hasRouterLinkUrl(): boolean {
    return !!this.routerLinkUrl().length;
  }

  public goToBack() {
    if (this.hasRouterLinkUrl) {
      this.router.navigate(this.routerLinkUrl(), {
        queryParams: this.queryParams(),
      });
    } else {
      this.location.back();
    }
  }
}
